import axios from "axios";
import apiURI from "./Api";

export default class AtecoReferenceService {
  async search(query) {
    const response = await axios.get(`${apiURI}/ateco-reference/search`, {
      params: { q: query },
    });
    return response.data;
  }
}
